import { render, staticRenderFns } from "./transfer.vue?vue&type=template&id=52f5673f&scoped=true"
import script from "./transfer.vue?vue&type=script&lang=js"
export * from "./transfer.vue?vue&type=script&lang=js"
import style0 from "./transfer.vue?vue&type=style&index=0&id=52f5673f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f5673f",
  null
  
)

export default component.exports